import actions from '@/core/store/ata/gestao-ata/actions'

export default {
	actions,
}
